// extracted by mini-css-extract-plugin
module.exports = {"designLibrary":"DesignLibrary_designLibrary__1uNK8","serviceBlock":"DesignLibrary_serviceBlock__30BxB"};